import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@sbd-account-portal/app/environments/environment';
import { PaymentResponse } from '@sbd-account-portal/app/modules/payment/payment.types';

@Injectable({ providedIn: 'root' })
export class PaymentService {
  private _httpClient = inject(HttpClient);


    purchaseQuoteRequest(data: any){
    return this._httpClient.post<PaymentResponse>(`${environment.apiBaseUrl}/v4/payment/purchase-qr`, data);
  }
}
